import script from "./StoragePage.vue?vue&type=script&setup=true&lang=js"
export * from "./StoragePage.vue?vue&type=script&setup=true&lang=js"

import "./StoragePage.vue?vue&type=style&index=0&id=6445f3e6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6445f3e6"]])

export default __exports__